<template>
  <div class="RoleFeature flex" :class="active ? 'active' : 'not-active'">
    <span class="mr-2" style="width: 16px; text-align: center">
      <font-awesome-icon icon="check" v-if="active" style="color: limegreen" />
      <font-awesome-icon icon="times" v-else style="color: #9ca3af" />
    </span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "RoleFeature",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.RoleFeature {
  display: flex;
  font-size: 0.9rem;
  &,
  * {
    transition-duration: 0ms;
  }

  &.not-active {
    color: #9ca3af;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/role/feature.vue